/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
declare var $:any;
@Component({
  templateUrl:'./signInHistoryEdit.html'
})

export class SignInHistoryEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location
  ){}

  private data:any={}

  private id:number = 0;
  private year = 0;
  private month = 0;

  private isCreate:boolean=false;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['id'];
      this.year=params['year'];
      this.month=params['month'];
    });

    if(this.id!=0){
      this.getData();
    }else {
      this.isCreate = true;
    }
  }


  private getData():void{
    this.HttpService.getData(API.signIn_history_detail+'?memberId='+this.id+'&year='+this.year+'&month='+this.month).then(res=>{
      this.data = res.data;
      let signList = [];
      for(let i=0;i<res.data.length;i++){
        signList.push(this.year+'/'+res.data[i]);
      }
      console.log(signList)
      this.initDate(new Date(this.year+'/'+this.month+'/01'),signList);
    })
  }

  private initDate(current,signList):void{
    /*日期签到*/
    var calUtil = {
      getDaysInmonth : function(iMonth, iYear){ //当前年月的总天数
        var dPrevDate = new Date(iYear, iMonth, 0);
        return dPrevDate.getDate();
      },
      bulidCal : function(iYear, iMonth) { //构建当前年月对应的日历
        var aMonth = new Array();
        aMonth[0] = new Array(7);
        aMonth[1] = new Array(7);
        aMonth[2] = new Array(7);
        aMonth[3] = new Array(7);
        aMonth[4] = new Array(7);
        aMonth[5] = new Array(7);
        aMonth[6] = new Array(7);
        var dCalDate = new Date(iYear, iMonth - 1, 1);
        var iDayOfFirst = dCalDate.getDay();
        var iDaysInMonth = calUtil.getDaysInmonth(iMonth, iYear);
        var iVarDate = 1;
        var d, w;
        aMonth[0][0] = "日";
        aMonth[0][1] = "一";
        aMonth[0][2] = "二";
        aMonth[0][3] = "三";
        aMonth[0][4] = "四";
        aMonth[0][5] = "五";
        aMonth[0][6] = "六";
        for (d = iDayOfFirst; d < 7; d++) {
          aMonth[1][d] = iVarDate;
          iVarDate++;
        }
        for (w = 2; w < 7; w++) {
          for (d = 0; d < 7; d++) {
            if (iVarDate <= iDaysInMonth) {
              aMonth[w][d] = iVarDate;
              iVarDate++;
            }
          }
        }
        return aMonth;
      },
      ifHasSigned : function(signList,day){
        var signed = false;
        $.each(signList,function(index,item){
          var date = new Date(item);
          if(date.getDate() == day) {
            signed = true;
            return false;
          }
        });
        return signed ;
      },
      drawCal : function(iYear, iMonth ,signList) {
        var currentYearMonth = iYear+"年"+iMonth+"月";
        var myMonth = calUtil.bulidCal(iYear, iMonth);
        var htmls = new Array();
        htmls.push("<div class='sign_main' id='sign_layer'>");
        htmls.push("<div class='sign_succ_calendar_title'>");
        htmls.push("<div class='calendar_month_span'>"+currentYearMonth+"</div>");
        htmls.push("</div>");
        htmls.push("<div class='sign' id='sign_cal'>");
        htmls.push("<table class='table'>");
        htmls.push("<tr>");
        htmls.push("<th>" + myMonth[0][0] + "</th>");
        htmls.push("<th>" + myMonth[0][1] + "</th>");
        htmls.push("<th>" + myMonth[0][2] + "</th>");
        htmls.push("<th>" + myMonth[0][3] + "</th>");
        htmls.push("<th>" + myMonth[0][4] + "</th>");
        htmls.push("<th>" + myMonth[0][5] + "</th>");
        htmls.push("<th>" + myMonth[0][6] + "</th>");
        htmls.push("</tr>");
        var d, w;
        for (w = 1; w < 7; w++) {
          htmls.push("<tr>");
          for (d = 0; d < 7; d++) {
            var ifHasSigned = calUtil.ifHasSigned(signList,myMonth[w][d]);
            if(ifHasSigned){
              htmls.push("<td class='on'>" + (!isNaN(myMonth[w][d]) ? myMonth[w][d] : " ") + "</td>");
            } else {
              htmls.push("<td>" + (!isNaN(myMonth[w][d]) ? myMonth[w][d] : " ") + "</td>");
            }
          }
          htmls.push("</tr>");
        }
        htmls.push("</table>");
        htmls.push("</div>");
        htmls.push("</div>");
        return htmls.join('');
      }
    };
    var str = calUtil.drawCal(current.getFullYear(),current.getMonth() + 1,signList);
    $("#calendar").html(str);



  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/badge/signInHistoryEdit.component.ts